import api from '../token';

export const AddFPagamento = async (dados) => {
  try {
    const response = await api.post('/addFPagamento', dados);
    return response.data;
  } catch (error) {
    
    return { success: false, message: error.message };
  }
};


